import axios from 'axios';
import { MESSAGE_API_URL } from '../utility/Constant';

export const sendSms = data => axios.post(`${MESSAGE_API_URL}/v1/messages/text_us`, data);
